import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1665f513"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header flex row justify-between max-w-7xl mx-auto p-20" }
const _hoisted_2 = { class: "flex w-auto max-w-7xl mx-auto px-20" }
const _hoisted_3 = { class: "w-1/3 text-right px-5 border-r-2 mr-10 border-dashed overflow-hidden overflow-ellipsis" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "font-display font-extrabold text-mainGreen text-3xl" }
const _hoisted_7 = {
  key: 0,
  class: "my-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Activity Level - ", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "leading-10"
}
const _hoisted_11 = { class: "w-2/3" }
const _hoisted_12 = {
  key: 0,
  class: "border grid grid-cols-8 p-5 mb-10"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-5xl pt-2" }, "👋", -1))
const _hoisted_14 = { class: "col-span-7 font-display text-2xl text-left" }
const _hoisted_15 = { class: "font-extrabold" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg" }, "This is your ether profile page", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left text-3xl font-medium" }, "Titles", -1))
const _hoisted_18 = {
  key: 1,
  class: "border bg-mainBg py-3 font-display text-lg"
}
const _hoisted_19 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_UserStatus = _resolveComponent("UserStatus")!
  const _component_TitleList = _resolveComponent("TitleList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Logo),
      _createVNode(_component_SearchBar, { class: "flex-grow" }),
      _createVNode(_component_UserStatus)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.profile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("img", {
                class: "icon",
                src: '/img/lvs/lv' + _ctx.profile.duration_level + '.jpeg'
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.ens) + ".eth ", 1),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.profile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("img", {
                    class: "icon",
                    src: '/img/lvs/ac' + _ctx.profile.active_level + '.jpeg'
                  }, null, 8, _hoisted_9),
                  _createElementVNode("div", null, "Account Value - " + _toDisplayString(_ctx.profile.tx_sum.toFixed(2)) + " ETH", 1),
                  _createElementVNode("div", null, "Transaction Count - " + _toDisplayString(_ctx.profile.tx_count), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, "No collections yet"))
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              class: "leading-5 text-xs",
              key: _ctx.address
            }, _toDisplayString(_ctx.address), 1))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.isOwner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, "Hello, " + _toDisplayString(_ctx.ens), 1),
                _hoisted_16
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_17,
        _createVNode(_component_TitleList, {
          titles: _ctx.titles,
          isOwner: _ctx.isOwner && !_ctx.loading
        }, null, 8, ["titles", "isOwner"]),
        (_ctx.loading || (!_ctx.isOwner && !_ctx.titles?.length))
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Loading..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, "No titles found for this domain"))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}